<p-tabs lazy [(value)]="selectedIndex" headerStyleClass="listingTab" scrollable="true">
  <div class="w-100 t-ar" style="padding: var(--p-tabs-tabpanel-padding)">
    <button pButton class="atlas-btn atlas-btn-secondary tall" (click)="addListing()">
      <span class="pi pi-plus-circle mr-5" style="font-size: 18px"></span> {{ 'listing.add-new' | translate |
      titlecase }}
    </button>
  </div>
  <p-tablist>
    @for (listing of value; track listing; let i = $index)
    {
    <p-tab [value]="i">
      <span style="font-size: 18px"></span> {{ listing.CategorySubCategory }}
    </p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    @for (listing of value; track listing; let i = $index)
    {
    <p-tabpanel [value]="i">
      <ng-template #content>
        <div class="mct-flex mct-justify-between mct-items-stretch">
          <div>
            <button [hidden]="!showViewListingButton" type="button" class="atlas-btn atlas-btn-default tall"
              (click)="onNavigateToListingDirectoryUrl(i)">
              {{ 'listing.view-listing.title' | translate | titlecase }}
            </button>
          </div>
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button"
              (click)="deleteListing(i)" title="{{ 'common.delete' | translate | titlecase }}">
              {{ 'common.delete' | translate | titlecase }}
            </button>
          </div>
        </div>
        <wl-profile-edit-listing [(ngModel)]="value[i]" (primaryListingSelected)="onPrimaryListingSelected($event)"
          (copyListingClicked)="copyListing($event)" [showEditor]="tabIsSelected && selectedIndex === i"
          [relatedProfileSelectItems]="relatedProfileSelectItems" [profileID]="profileId" [listingTypes]="listingTypes"
          [categories]="categories" [listingPositions]="listingPositions" [tenantHttpsUrl]="tenantHttpsUrl"
          [entities]="entities" [entityDomains]="entityDomains"></wl-profile-edit-listing>
      </ng-template>
    </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>

<p-dialog #unsavedChangesModal modal="true" [(visible)]="openViewListingDialog" [closable]="false"
  styleClass="atlas-dialog-m" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <p *ngIf="isDirty()">{{ 'listing.view-listing.unsaved-changes-prompt' | translate }}</p>
  <p *ngIf="!isDirty()">{{ 'listing.view-listing.confirm-redirect' | translate | ucfirst }}</p>
  <ng-template pTemplate="footer">
    <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
    <button pButton type="button" class="btn btn-primary" [disabled]="isSaving" [hidden]="!isDirty()"
      (click)="handleSaveClick()" [icon]="isSaving ? '' : 'pi pi-save'"
      [label]="(isSaving ? 'common.saving' : 'common.save') | translate | titlecase"></button>

    <button pButton type="button" class="btn btn-primary" icon="pi pi-external-link"
      (click)="handleNavigateToListingDirectoryUrl()" [hidden]="isSaving || isDirty()"
      [disabled]="isSaving || isDirty()" [label]="'listing.view-listing.title' | translate | titlecase"></button>
    <cancel-button [label]="'common.cancel' | translate | titlecase" styleClass="atlas-btn-default"
      [disabled]="isSaving" (onClick)="handleCancelClick()">
    </cancel-button>
  </ng-template>
</p-dialog>
